import { render, staticRenderFns } from "./ModalNovosTermos.vue?vue&type=template&id=d81ac1cc&"
import script from "./ModalNovosTermos.vue?vue&type=script&lang=js&"
export * from "./ModalNovosTermos.vue?vue&type=script&lang=js&"
import style0 from "./ModalNovosTermos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports